import { IonBadge } from '@ionic/react';

import { Icon } from '@/components/memo';
import {
  REQUEST_STATUS_ACTIVE_ICONS,
  REQUEST_STATUS_ICONS
} from '@/utils/constants';
import capitalize from '@/utils/helpers/capitalize';

import './StatusOptions.css';

interface StatusOptionsProps {
  selectedStatus: string;
  onStatusChange: (status: string) => void;
  statusOptions: string[];
  pendingRequestsCount: number;
}

const StatusOptions: React.FC<StatusOptionsProps> = ({
  selectedStatus,
  onStatusChange,
  statusOptions,
  pendingRequestsCount
}) => {
  return (
    <div className="status-options">
      {statusOptions.map((status: string) => (
        <div
          key={status}
          className={`status-options__option ${selectedStatus === status ? 'status-options__option--selected' : ''}`}
          onClick={() => onStatusChange(status)}
        >
          <Icon
            icon={
              selectedStatus === status
                ? REQUEST_STATUS_ACTIVE_ICONS[status]
                : REQUEST_STATUS_ICONS[status]
            }
          />
          <p className="status-options__label">{capitalize(status)}</p>
          {status === 'pending' && pendingRequestsCount > 0 && (
            <IonBadge color="danger">{pendingRequestsCount}</IonBadge>
          )}
        </div>
      ))}
    </div>
  );
};

export default StatusOptions;
